<template>
    <div class="wrap">
        <div class="title">
            <div class="title_left">家长访问审核</div>
        </div>

        <div class="tabBox">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="activeSelect">
                <el-menu-item class="mrAll20" index="1">待审核</el-menu-item>
                <el-menu-item class="mrAll20" index="2">已通过</el-menu-item>
                <el-menu-item class="mrAll20" index="3">已驳回</el-menu-item>
            </el-menu>
        </div>

        <div class="innerBox">
            <div class="filtrate">
                <el-input placeholder="学生姓名,学生身份证号,申请人监护人手机" class="w280 seekIpt mr20" v-model="queryLimit.keyword">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="searchPage"></i>
                </el-input>
                <span class="mr10" v-if="activeIndex == '1' || activeIndex == '2'">申请日期:</span>
                <span class="mr10" v-if="activeIndex == '3'">驳回日期:</span>
                <el-date-picker @change="handleDateClick" value-format="yyyy-MM-dd" class=" w140 mr10" type="date"
                                v-model="queryLimit.applyDateBegin" clearable
                                placeholder="选择起始日期" :picker-options="beforeDate"></el-date-picker>
                至
                <el-date-picker @change="handleDateClick" value-format="yyyy-MM-dd" v-model="queryLimit.applyDateEnd"
                                class=" w140 ml10 mr20" type="date" clearable
                                placeholder="选择截止日期" :picker-options="afterDate"></el-date-picker>
                <span class="mr10">入学年份:</span>
                <el-date-picker @change="handleYearClick" value-format="yyyy" class=" w140 mr10" type="year"
                                v-model="queryLimit.startYearBegin" clearable
                                placeholder="选择起始年份" :picker-options="beforeYear"></el-date-picker>
                至
                <el-date-picker @change="handleYearClick" value-format="yyyy" v-model="queryLimit.startYearEnd"
                                class=" w140 ml10 mr20" type="year" clearable
                                placeholder="选择截止年份" :picker-options="afterYear"></el-date-picker>
            </div>
            <div class="operate clear_a" v-if="activeIndex == 1">
                <div class="left mt20">
                    <el-button class="mr20" @click="batchPass">批量通过</el-button>
                    <el-button class="mr20" @click="refuseApply">批量驳回</el-button>
                </div>
            </div>
            <el-divider></el-divider>
            <div class="content">
                <div class="tabOffTop120">
                    <!-- v-loading="loading" element-loading-text="数据正在努力加载中"  -->
                    <el-table ref="multipleTable" :data="tableData.records" tooltip-effect="dark" style="width: 100%"
                              @selection-change="handleSelectionChange" @sort-change="sortChange"
                    >
                        <el-table-column type="selection" width="55" key="a0" v-if="activeIndex == 1">
                        </el-table-column>
                        <el-table-column label="学生姓名" width="120" key="a1" show-overflow-tooltip>
                            <template slot-scope="scope">{{ scope.row.stuName }}</template>
                        </el-table-column>
                        <el-table-column prop="stuIdentity" key="a2" label="学生身份证号" min-width="180"
                                         show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="stuClass" min-width="120" key="a3" label="所属班级" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column label="班主任" key="a4">
                            <template slot-scope="scope">{{ scope.row.headTeacher == ''? '暂无': scope.row.headTeacher}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="stuStartYear" key="a5" width="120" label="入学年份" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column min-width="120" key="a6" label="监护人姓名" show-overflow-tooltip>
                            <template slot-scope="scope">{{ scope.row.parentsName == ''? '暂无': scope.row.parentsName}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="parentsMobile" key="a7" width="150" label="监护人手机号" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="createTime" ref="sort" key="a8" width="180" label="申请时间"
                                         show-overflow-tooltip
                                         sortable='custom'>
                        </el-table-column>
                        <el-table-column v-if="activeIndex == '2'"  key="a9" prop="optTime" width="200"
                                         label="通过时间"
                                         show-overflow-tooltip sortable='custom'>
                        </el-table-column>
                        <el-table-column v-if="activeIndex == '3'"  key="a10" prop="optTime" width="200"
                                         label="驳回时间"
                                         show-overflow-tooltip sortable='custom'>
                        </el-table-column>
                        <el-table-column v-if="activeIndex == '3'" key="a11" prop="reason" min-width="200"
                                         label="驳回原因" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column label="操作" min-width="150" key="a12" v-if="activeIndex =='1'">
                            <template slot-scope="scope" v-if="activeIndex == '1'">
                                <a href="javascript:;" class="operate-a" @click="passApply(scope.row.id)">通过</a>
                                <a href="javascript:;" class="operate-a" @click="disposeApply(scope.row.id)">驳回</a>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
                <div class="pagination-box">
                    <el-pagination background @size-change="pageSizeChange" @current-change="pageCurrentChange"
                                   :current-page="queryLimit.current" :page-sizes="[10, 20, 30, 40,50]"
                                   :page-size="queryLimit.size"
                                   layout="total,prev, pager, next, sizes, jumper" :total="tableData.total">
                    </el-pagination>
                </div>
            </div>
        </div>

        <el-dialog
                title="驳回原因"
                :visible.sync="refuseDialog"
                :close-on-click-modal="false"
                width="25%"
                :before-close="cancel"
        >
            <el-input type="textarea" :rows="4" v-model="refuseReason" placeholder="请输入驳回原因, 5字以上, 必填"></el-input>
            <span slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="auditDatas()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import * as api from "api/auditList";

    export default {
        name: "wlList",
        data() {
            return {
                queryLimit: {
                    current: 1,
                    size: 10,
                    keyword: "",
                    applyDateBegin: "",
                    applyDateEnd: "",
                    applyDateOrder: "",
                    optDateOrder: "",
                    startYearBegin: "",
                    startYearEnd: "",
                    state: 1
                },
                tableData: [],
                multipleSelection: [],
                afterDate: {
                    disabledDate: (time) => {
                        let startDate = new Date(this.queryLimit.applyDateBegin);
                        if (this.queryLimit.applyDateBegin) {
                            return time.getTime() < startDate - 8.64e7;
                        }
                    }
                },
                beforeDate: {
                    disabledDate: (time) => {
                        let endDate = new Date(this.queryLimit.applyDateEnd);
                        if (this.queryLimit.applyDateEnd) {
                            return time.getTime() > endDate;
                        }
                    }
                },
                beforeYear: {
                    disabledDate: (year) => {
                        let endDate = new Date(this.queryLimit.startYearEnd);
                        if (this.queryLimit.startYearEnd) {
                            return year > endDate;
                        }
                    }
                },
                afterYear: {
                    disabledDate: (year) => {
                        let startDate = new Date(this.queryLimit.startYearBegin);
                        if (this.queryLimit.startYearBegin) {
                            return year < startDate;
                        }
                    }
                },
                activeIndex: "1",
                refuseDialog: false,
                delId: [],
                status: '',
                refuseReason: ''
            };
        },
        methods: {
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            pageCurrentChange(current) {
                this.queryLimit.current = current;
                this.getPageData();
            },
            pageSizeChange(size) {
                this.queryLimit.size = size;
                this.getPageData();
            },
            handleDateClick() {
                if (this.queryLimit.applyDateBegin && this.queryLimit.applyDateEnd || this.queryLimit.applyDateBegin === null && this.queryLimit.applyDateEnd === null) {
                    this.searchPage();
                }
            },
            handleYearClick() {
                if (this.queryLimit.startYearBegin && this.queryLimit.startYearEnd || this.queryLimit.startYearBegin === null && this.queryLimit.startYearEnd === null) {
                    this.searchPage();
                }
            },
            activeSelect(key) {
                this.activeIndex = key;
                this.queryLimit.state = key;
                this.queryLimit.current = 1;
                this.queryLimit.keyword = "";
                this.queryLimit.applyDateBegin = "";
                this.queryLimit.applyDateEnd = "";
                this.queryLimit.startYearBegin = "";
                this.queryLimit.startYearEnd = "";
                this.queryLimit.optDateOrder = "";
                this.queryLimit.applyDateOrder = "";
                this.$refs.sort.columnConfig.order = '';
                this.getPageData();
            },
            refuseApply() {
                if (this.delTips()) {
                    this.refuseDialog = true;
                    this.status = 'batch'
                }
            },
            sortChange(column) {
                if (column.order == "ascending") {
                    if (column.prop == "createTime") {
                        this.queryLimit.applyDateOrder = "ASC";
                        this.queryLimit.optDateOrder = "";
                    }
                    if (column.prop == "optTime") {
                        this.queryLimit.optDateOrder = "ASC";
                        this.queryLimit.applyDateOrder = "";
                    }
                }
                if (column.order == "descending") {
                    if (column.prop == "createTime") {
                        this.queryLimit.applyDateOrder = "DESC";
                        this.queryLimit.optDateOrder = "";
                    }
                    if (column.prop == "optTime") {
                        this.queryLimit.optDateOrder = "DESC";
                        this.queryLimit.applyDateOrder = "";
                    }
                }
                this.searchPage();
            },
            async batchPass() {
                if (this.delTips()) {
                    try {
                        await this.$confirm('审核通过后，会自动加入访问白名单。是否确认审核通过？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        })
                        let idArr = []
                        this.multipleSelection.map(item => {
                            idArr.push(item.id)
                        })
                        let result = await api.auditInfo({
                            idList: idArr,
                            reason: '',
                            result: true
                        })
                        if (result.code == 200) {
                            this.$message.success('操作成功!');
                            this.getPageData();
                        }
                    } catch (e) {
                        this.$message({
                            type: 'info',
                            message: '通过失败'
                        });
                    }
                }
            },
            delTips() {
                if (!this.multipleSelection.length > 0) {
                    this.$message({
                        message: "勾选需要数据后才能批量操作哦",
                        type: "warning"
                    });
                    return false;
                } else if (this.multipleSelection.length > 0) {
                    return true;
                }
            },
            searchPage() {
                this.queryLimit.current = 1;
                this.getPageData();
            },
            async getPageData() {
                let result = await api.getAuditList(this.queryLimit);
                this.tableData = result.data;
            },
            cancel() {
                this.refuseDialog = false
                this.refuseReason = ''
            },
            async auditDatas() {
                if (this.refuseReason == '' || this.refuseReason.length < 5) {
                    this.$message({
                        message: '驳回理由必填, 且须5个字以上',
                        type: 'warning'
                    });
                    return
                }
                let idArr = []
                this.multipleSelection.map(item => {
                    idArr.push(item.id)
                })
                let id = this.status == 'single' ? this.delId : idArr;
                let result = await api.auditInfo({
                    "idList": id,
                    "reason": this.refuseReason,
                    "result": false
                });
                if (result.code == 200) {
                    this.$message.success('操作成功!');
                    this.refuseReason = ''
                    this.refuseDialog = false;
                    this.getPageData();
                }
            },
            async passApply(id) {
                try {
                    await this.$confirm('审核通过后，会自动加入访问白名单。是否确认审核通过？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                    let newArr = [];
                    newArr.push(id);
                    let result = await api.auditInfo(
                        {
                            idList: newArr,
                            reason: '',
                            result: true
                        }
                    );
                    if (result.code == 200) {
                        this.$message.success('操作成功!');
                        this.getPageData();
                    }
                } catch (e) {
                    this.$message({
                        type: 'info',
                        message: '通过失败'
                    });
                }

            },
            disposeApply(id) {
                this.delId = []
                this.delId.push(id)
                this.status = 'single';
                this.refuseDialog = true;
            }
        },
        mounted() {
            this.getPageData();
        }
    };
</script>

<style scoped lang="scss">
    .line {
        width: 100%;
        height: 1px;
        background: #eeeeee;
    }

    .wrap {
        width: calc(100% - 40px);
        padding: 0 20px;
        height: 100%;
        background: #f6f6f6;
        .title {
            height: 60px;
            line-height: 60px;
            .title_left {
                font-size: 20px;
                font-weight: 400;
                color: rgba(51, 51, 51, 1);
                width: 50%;
                height: 100%;
            }
        }
        .tabBox {
            width: 100%;
            background: #fff;
            border-radius: 10px;
            margin-bottom: 10px;
            .el-menu-demo {
                border-radius: 4px;
                .mrAll20 {
                    margin: 0 20px;
                    border-bottom-width: 4px !important;
                }
            }
        }
        .innerBox {
            width: calc(100% - 60px);
            padding: 20px 30px;
            height: calc(100% - 175px);
            background: #fff;
            border-radius: 10px;
            overflow: scroll;
            .filtrate {
                vertical-align: center;
                .year {
                    font-size: 12px;
                    line-height: 18px;
                    color: #666666;
                }
            }
            .operate {
                .left {
                    float: left;
                }
                .right {
                    float: right;
                }
            }
        }
        .module {
            background: #fff;
            width: 720px;
            height: 400px;
            margin: 0;
            padding: 0;
            .header {
                width: 100%;
                height: 60px;
                .left_header {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 358px;
                    height: 100%;
                    border-right: 1px solid #eeeeee;
                    box-sizing: border-box;
                }
                .right_header {
                    width: 358px;
                    height: 100%;
                    .title {
                        float: left;
                        font-size: 16px;
                        color: #333333;
                        line-height: 22px;
                        margin: 19px 0 0 30px;
                        display: inline-block;
                    }
                    .statistic {
                        font-size: 14px;
                        color: #999999;
                        line-height: 20px;
                        margin-top: 19px;
                        float: right;
                        display: inline-block;
                    }
                }
            }
            .textTip {
                text-align: center;
            }
            .left_module {
                width: 358px;
                height: 340px;
                display: inline-block;
                border-top: 1px solid #eeeeee;
                border-bottom: 1px solid #eeeeee;
                border-right: 1px solid #eeeeee;
                box-sizing: border-box;
                padding: 20px;
                overflow: scroll;
            }
            .right_module {
                width: 358px;
                height: 340px;
                display: inline-block;
                border-top: 1px solid #eeeeee;
                border-bottom: 1px solid #eeeeee;
                box-sizing: border-box;
                padding: 20px;
                overflow: scroll;
            }
        }
        .pagination-box {
            text-align: right;
            margin-top: 20px;
        }
    }
</style>